import React from "react";

function LoadingState() {
  return (
    <main className="relative min-h-screen overflow-hidden bg-slate-50 px-4 pb-16 pt-28 font-satoshi dark:bg-slate-950 sm:px-6 lg:px-8">
      <div className="absolute inset-x-0 top-0 h-72 bg-slate-950" />

      <section className="relative mx-auto max-w-6xl">
        <div className="mb-7 h-36 animate-pulse rounded-[2rem] bg-white/10" />

        <div className="grid gap-6 lg:grid-cols-[0.9fr_1.1fr]">
          <div className="h-96 animate-pulse rounded-[2rem] bg-white shadow-xl dark:bg-white/[0.06]" />
          <div className="h-96 animate-pulse rounded-[2rem] bg-white shadow-xl dark:bg-white/[0.06]" />
        </div>
      </section>
    </main>
  );
}

export default LoadingState;